/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Performancetable_Collections_Topsellers2Inputs */

const id_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terlaris`)
};

const ms_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terlaris`)
};

const da_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedst sælgende`)
};

const de_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meistverkauft`)
};

const en_us2_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Sellers`)
};

const es_es2_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más vendidos`)
};

const es_mx2_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más vendidos`)
};

const fil_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinakamabenta`)
};

const fr_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meilleures ventes`)
};

const it_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Più venduti`)
};

const hu_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legkelendőbbek`)
};

const nl_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best verkopend`)
};

const no_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mest solgte`)
};

const pl_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najlepiej sprzedawane`)
};

const pt_br2_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais vendidos`)
};

const pt_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais vendidos`)
};

const ro_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cele mai vândute`)
};

const fi_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Myydyimmät`)
};

const sv_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bästsäljare`)
};

const vi_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bán chạy nhất`)
};

const tr_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En Çok Satanlar`)
};

const cs_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejprodávanější`)
};

const bg_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Най-продавани`)
};

const ru_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лидеры продаж`)
};

const uk_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найпродаваніші`)
};

const ar_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأكثر مبيعًا`)
};

const hi_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टॉप सेलर्स`)
};

const th_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ขายดีที่สุด`)
};

const ja_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トップセラー`)
};

const zh_cn2_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`畅销榜`)
};

const zh_hant1_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暢銷榜`)
};

const ko_components_performancetable_collections_topsellers2 = /** @type {(inputs: Components_Performancetable_Collections_Topsellers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`판매 상위`)
};

/**
* | output |
* | --- |
* | "Top Sellers" |
*
* @param {Components_Performancetable_Collections_Topsellers2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_performancetable_collections_topsellers2 = /** @type {((inputs?: Components_Performancetable_Collections_Topsellers2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Performancetable_Collections_Topsellers2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_performancetable_collections_topsellers2(inputs)
	if (locale === "ms") return ms_components_performancetable_collections_topsellers2(inputs)
	if (locale === "da") return da_components_performancetable_collections_topsellers2(inputs)
	if (locale === "de") return de_components_performancetable_collections_topsellers2(inputs)
	if (locale === "en-US") return en_us2_components_performancetable_collections_topsellers2(inputs)
	if (locale === "es-ES") return es_es2_components_performancetable_collections_topsellers2(inputs)
	if (locale === "es-MX") return es_mx2_components_performancetable_collections_topsellers2(inputs)
	if (locale === "fil") return fil_components_performancetable_collections_topsellers2(inputs)
	if (locale === "fr") return fr_components_performancetable_collections_topsellers2(inputs)
	if (locale === "it") return it_components_performancetable_collections_topsellers2(inputs)
	if (locale === "hu") return hu_components_performancetable_collections_topsellers2(inputs)
	if (locale === "nl") return nl_components_performancetable_collections_topsellers2(inputs)
	if (locale === "no") return no_components_performancetable_collections_topsellers2(inputs)
	if (locale === "pl") return pl_components_performancetable_collections_topsellers2(inputs)
	if (locale === "pt-BR") return pt_br2_components_performancetable_collections_topsellers2(inputs)
	if (locale === "pt") return pt_components_performancetable_collections_topsellers2(inputs)
	if (locale === "ro") return ro_components_performancetable_collections_topsellers2(inputs)
	if (locale === "fi") return fi_components_performancetable_collections_topsellers2(inputs)
	if (locale === "sv") return sv_components_performancetable_collections_topsellers2(inputs)
	if (locale === "vi") return vi_components_performancetable_collections_topsellers2(inputs)
	if (locale === "tr") return tr_components_performancetable_collections_topsellers2(inputs)
	if (locale === "cs") return cs_components_performancetable_collections_topsellers2(inputs)
	if (locale === "bg") return bg_components_performancetable_collections_topsellers2(inputs)
	if (locale === "ru") return ru_components_performancetable_collections_topsellers2(inputs)
	if (locale === "uk") return uk_components_performancetable_collections_topsellers2(inputs)
	if (locale === "ar") return ar_components_performancetable_collections_topsellers2(inputs)
	if (locale === "hi") return hi_components_performancetable_collections_topsellers2(inputs)
	if (locale === "th") return th_components_performancetable_collections_topsellers2(inputs)
	if (locale === "ja") return ja_components_performancetable_collections_topsellers2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_performancetable_collections_topsellers2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_performancetable_collections_topsellers2(inputs)
	return ko_components_performancetable_collections_topsellers2(inputs)
});
export { components_performancetable_collections_topsellers2 as "components.performanceTable.collections.topSellers" }